import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

/** Loads the appointment types a member can book for one pet. */
export function useListPetAppointmentTypes(patientId: string) {
  const api = usePortalApi()

  return useQuery({
    queryKey: ['pet-appointment-types', patientId],
    enabled: !!patientId,
    staleTime: 0,
    queryFn: async () =>
      dataOrThrow(await api.get('/pets/:id/appointment-types', { params: { id: patientId } })),
  })
}
